const Domains = [
  { label: "UI/UX Designer", value: "1" },
  { label: "Web developer", value: "2" },
  { label: "React Native Developer", value: "3" },
  { label: "Flutter Development", value: "4" },
];

export default Domains;
